import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import _ from 'lodash'
import {ORIGINAL_PATH_TO_PACKED, STYLE_DATA_PATH, CUSTOM_STYLE_NAMESPACE, URL_PARAM_TO_PATH} from './constants'
import {unpackFromQueryParams} from '../../utils/urlParams'

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    // extract width and height from src to data
    component.src = unpackFromQueryParams(component, 'src', URL_PARAM_TO_PATH)
    // convert width and height to number
    _.forEach(Object.values(URL_PARAM_TO_PATH), path => {
        const value = _.get(component, path)
        if (value) {
            _.set(component, path, parseInt(value, 10))
        }
    })

    _.forEach(ORIGINAL_PATH_TO_PACKED, (stylePath, originalPath) => {
        const value = _.get(component, stylePath)
        if (!_.isNil(value)) {
            _.set(component, originalPath, value)
            _.unset(component, stylePath)
            const parentPath = stylePath.split('.').slice(0, -1)
            if (_.isEmpty(_.get(component, parentPath))) {
                _.unset(component, parentPath)
            }
        }
    })

    const customStyleNamespaceData = _.get(component, STYLE_DATA_PATH)
    const customStyleDataKeys = _.keys(customStyleNamespaceData)
    const customStyleDataHasOnlyTypeField = customStyleDataKeys.length === 1 && customStyleDataKeys[0] === 'type'

    if (_.isEmpty(customStyleNamespaceData) || customStyleDataHasOnlyTypeField) {
        delete component[CUSTOM_STYLE_NAMESPACE]
    }
}
